import { useContext } from 'react';
import AlertContext from '../context/AlertContext';

const useMessageAlert = () => useContext(AlertContext);

export default useMessageAlert;
